module.exports = __webpack_public_path__ + "static/img/8.4415c15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/8.png
// module id = jTHQ
// module chunks = 0